import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { tampleteComapnyAssignRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { companiesListKey } from '../constants';

type useAssignCompanyProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useAssignCompany = ({
    setErrorText = () => { },
}: useAssignCompanyProps) => {
    const client = useQueryClient();

    const { mutate: assignCompany, isLoading: isAssigningCompany } =
        useMutation({
            mutationFn: (variables: {
                company_id: string | number
                template_id: string | number
            }) =>
                axiosInstance
                    .post(tampleteComapnyAssignRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    client.invalidateQueries([companiesListKey]);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        assignCompany,
        isAssigningCompany,
    };
};
